import axios from "@/http";
import { handleGetRequestParams } from '@/common/js/util'

class StorageManageMent {
  /* 储位管理列表 */
  static getStorageManageMentList(options) {
    let url = `/zwy/api/project/warehouse/area/import/page?`;
    url += handleGetRequestParams(options)
    return axios.get(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 订单导入
  static postExcel(data) {
    const url = `/zwy/api/upload/project/area/num`
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  /* 获取储位导入模板 */
  static getStorageTmp(warehouseId) {
    const url = `/zwy/api/download/warehouse/area/template?warehouseId=${warehouseId}`
    return axios.get(url, { responseType: "blob" }).then(res => {
      return Promise.resolve(res);
    });
  }
}

export default StorageManageMent;